module.exports = __webpack_public_path__ + "media/images/faces/female/21-af6d754022810c019a9f6a323c098d8b.jpg";